import {
  AxaMembershipNumber,
  CrestMembershipNumber,
  CrestMembershipNumberWithLetters,
  HolMembershipNumber
} from "../constants/RegexConstants";
import { Layouts } from "../constants/Constants";

export class MembershipNumberValidation {
  static statuses = {
    empty: "Please enter your membership number.",
    invalid: "The membership number you have entered is incorrect"
  };
  static isValidHarpaPolicy(membershipNumber) {
    if (membershipNumber) {
      if (
        AxaMembershipNumber.test(membershipNumber) ||
        HolMembershipNumber.test(membershipNumber)
      ) {
        return true;
      }
    }
    return false;
  }

  static isValid(membershipNumber, layout) {
    if (!membershipNumber) {
      return [this.statuses.empty];
    } else if (layout) {
      if (
        layout === Layouts.HOL &&
        HolMembershipNumber.test(membershipNumber)
      ) {
        return [];
      } else if (
        layout === Layouts.MOL &&
        (AxaMembershipNumber.test(membershipNumber) ||
          CrestMembershipNumber.test(membershipNumber) ||
          CrestMembershipNumberWithLetters.test(membershipNumber) ||
          HolMembershipNumber.test(membershipNumber))
      ) {
        return [];
      }
    } else {
      if (AxaMembershipNumber.test(membershipNumber)) {
        return [];
      } else if (CrestMembershipNumberWithLetters.test(membershipNumber)) {
        return [];
      } else if (CrestMembershipNumber.test(membershipNumber)) {
        return [];
      } else if (HolMembershipNumber.test(membershipNumber)) {
        return [];
      }
    }
    return [this.statuses.invalid];
  }
}

export default MembershipNumberValidation;
